export const getVerifyPassword = "api/v1/user/verify";
export const loginData = "api/v1/user/login_data";
export const getPersonas = "api/v1/user/personas";
export const askMessage = "api/v1/user/askinstant";
export const generateSummary = "api/v1/user/generate-summary";
export const logOut = "api/v1/user/logout";
export const adminLogin = "api/v1/user/admin_login";
export const adminHearingLogin = "api/v1/user/hearing-test-verify";
export const personaUpdate = "api/v1/user/persona-update";
export const audioTranscribe = "api/v1/user/transcribe";
export const getDefaultPersona = "api/v1/user/persona-get-default";
export const cleanSession = "api/v1/user/clean-session-history";
export const sessionLists = "api/v1/user/sessions-lists";
export const createSession = "api/v1/user/create-session";
export const updateSession = "api/v1/user/sessions-update";
export const sessionsDelete = "api/v1/user/sessions-delete";
export const sessionActive = "api/v1/user/sessions-active";
export const joinSession = "api/v1/user/join-session";
export const downloadSession = "api/v1/user/session/download";
export const sessionCheck = "api/v1/user/session/verify_user";
